import { ButtonBase, Menu, MenuItem } from '@mui/material';
import { Typography, colors, Tooltip } from '@sweep-io/sweep-design';
import { ChevronDown } from '@sweep-io/sweep-design/dist/icons';
import { AiAgent } from './aiAgentsConsts';
import BetaTag from '../common/BetaTag';
import { AgentType } from '@server/ai';
import usePopover from '../../hooks/usePopover';
import { useAgentActions } from './useAgentActions';

export const AgentNameButton = ({ agent }: { agent: AiAgent }) => {
  const { openPopover, closePopover, isPopoverOpen, anchorElement, anchorRef } = usePopover();
  const { newChatAction, settingsAction, renameAction, deleteAction, renameDialog } =
    useAgentActions(agent, {
      origin: 'agent_name_button',
      mode: 'expanded',
    });

  // Actions to show in the header menu
  const actions = [
    { action: newChatAction, label: 'New chat' },
    { action: settingsAction, label: 'Settings' },
    { action: renameAction, label: 'Rename agent' },
  ];

  if (deleteAction) {
    actions.push({ action: deleteAction, label: 'Delete agent' });
  }

  return (
    <>
      <ButtonBase
        ref={anchorRef}
        onClick={openPopover}
        sx={{
          height: '32px',
          borderRadius: '4px',
          padding: '0 8px',
          backgroundColor: isPopoverOpen ? colors.grey[100] : colors.white,
          '&:hover': {
            backgroundColor: colors.grey[100],
          },
          display: 'flex',
          gap: '8px',
        }}
      >
        <Typography variant="h4">{agent?.name}</Typography>
        {agent?.type === AgentType.Permissions && <BetaTag />}
        <ChevronDown size="small" />
      </ButtonBase>

      <Menu
        anchorEl={anchorElement}
        open={isPopoverOpen}
        onClose={closePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            style: {
              width: '162px',
            },
          },
        }}
      >
        {actions.map((item) => (
          <Tooltip
            key={item.label}
            title={item.action.disabled ? item.action.disabledTooltip : undefined}
            placement="right"
          >
            <span>
              <MenuItem
                onClick={() => {
                  if (!item.action.disabled) {
                    item.action.onClick();
                  }
                  closePopover();
                }}
                disabled={item.action.disabled}
                sx={{
                  color: item.action.color || undefined,
                }}
              >
                {item.label}
              </MenuItem>
            </span>
          </Tooltip>
        ))}
      </Menu>
      {renameDialog}
    </>
  );
};
